import {
  parseTranslations,
  CommonTranslations,
  Logout,
  Sites
} from '@pmi/pmi-iqos-shared-react'
import LogoutTranslations from './logout.json'

Logout.componentTranslations = {
  ...LogoutTranslations,
  ...CommonTranslations
}

Logout.componentDefaultProps = {
  ...Logout.componentDefaultProps,
  translations: {
    ...parseTranslations(Logout.componentTranslations, true)
  },
  site: Sites.iqosphere
}

Logout.onLogoutSuccessAdditionalAction = async () => {}

export default Logout
